import { routeAction } from "./routeActions";
import { RoutingFactors } from "./routerules/types";

export const determineNextRoute = (
  currentRoute: string | undefined,
  routingFactors: RoutingFactors
) =>
  currentRoute && routeAction[currentRoute]
    ? routeAction[currentRoute](routingFactors)
    : "/";
